import { inject, Injectable, signal } from '@angular/core';
import { BaseResponse } from '@ibc-shared/model/base-response.model';
import { Observable } from 'rxjs';
import { PreRegistrationStatus } from '../models/preregistration-status.model';
import { User } from '../models/user.model';
import { UserRepository } from '../repositories/users.repository';

@Injectable({ providedIn: 'root' })
export class UserService {
  private readonly repo = inject(UserRepository);

  public currentRegistration = signal<PreRegistrationStatus | null>(null);

  public createUser(user: User): Observable<BaseResponse<User>> {
    return this.repo.createUser(user);
  }

  public getUserById(id: string): Observable<BaseResponse<User>> {
    return this.repo.getUserById(id);
  }

  public updateUser(id: string, user: Partial<User>): Observable<BaseResponse<User>> {
    return this.repo.updateUser(id, user);
  }

  public confirmAccount(token: { token: string }): Observable<BaseResponse<string>> {
    return this.repo.sendConfirmationAccountValidation(token);
  }

  public getRegistration(userId: string | number): Observable<PreRegistrationStatus | null> {
    return this.repo.getRegistration(userId);
  }
}
